import React, { forwardRef, useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    OutlinedInput
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { apiCreateCounterParty, apiGetCounterParty } from '@store';
import { useDispatch } from 'react-redux';
import { showToast } from '@utils';
import { useCountries } from '../../../hooks/useCountry';
import { CircularProgress, MenuItem, Select } from '@mui/material';

const CreateCounterParty = forwardRef(({ handleClose }, ref) => {
    const dispatch = useDispatch();
    const [state, setState] = useState({
        name: '',
        country: '',
        location: '',
        phone: '',
        bank_details: ''
    });
      const { countries, loading, error } = useCountries();


    const handleChange = (e) => {
        const key = e.target.name || e.target.id;
        setState({
            ...state,
            [key]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await dispatch(apiCreateCounterParty(state));
        if (response.meta.requestStatus === 'fulfilled') {
            dispatch(apiGetCounterParty());
            handleClose();
            showToast('success', 'Counterparty created successfully');
        } else if (response.meta.requestStatus === 'rejected') {
            showToast('error', response.error?.message || 'Failed to create counterparty');
        } else {
            showToast('error', 'An error occurred');
        }
    };

    return (
        <Box
            className="modal-container"
            component="form"
            onSubmit={handleSubmit}
        >
            <Box className="flex justify-between modal-header">
                <h2 className="modal-title">Create Counterparty</h2>
                <CloseIcon className="cursor-pointer" onClick={handleClose} />
            </Box>
            <div className="modal-body">
                <FormControl fullWidth={true} variant="outlined" sx={{ mb: 2 }}>
                    <InputLabel id="nameLabel">Name *</InputLabel>
                    <OutlinedInput
                        id="name"
                        name="name"
                        label="Name"
                        value={state.name}
                        onChange={handleChange}
                        required
                    />
                </FormControl>
                <FormControl fullWidth={true} variant="outlined" sx={{ mb: 2 }} error={!!error}>
                    <InputLabel id="countryLabel">Country *</InputLabel>
                    <Select
                        labelId="countryLabel"
                        id="country"
                        name="country"
                        value={state.country || ''} 
                        onChange={handleChange}
                        label="Country"
                        required
                        disabled={loading}
                        endAdornment={loading ? <CircularProgress size={20} sx={{ mr: 3 }} /> : null}
                    >
                        {error ? (
                            <MenuItem disabled value="">
                                <em>Error loading countries</em>
                            </MenuItem>
                        ) : (
                            countries.map((countryName) => (
                                <MenuItem key={countryName} value={countryName}>
                                    {countryName}
                                </MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>
                <FormControl fullWidth={true} variant="outlined" sx={{ mb: 2 }}>
                    <InputLabel id="phoneLabel">Phone</InputLabel>
                    <OutlinedInput
                        id="phone"
                        name="phone"
                        label="Phone"
                        type="tel"
                        value={state.phone}
                        onChange={handleChange}
                    />
                </FormControl>
                <FormControl fullWidth={true} variant="outlined" sx={{ mb: 2 }}>
                    <InputLabel id="locationLabel">Location *</InputLabel>
                    <OutlinedInput
                        id="location"
                        name="location"
                        label="Location"
                        value={state.location}
                        onChange={handleChange}
                        required
                    />
                </FormControl>
                {/* <FormControl fullWidth={true} variant="outlined" sx={{ mb: 2 }}>
                    <InputLabel id="bankDetailsLabel">Bank Details</InputLabel>
                    <OutlinedInput
                        id="bank_details"
                        label="Bank Details"
                        value={state.bank_details}
                        onChange={handleChange}
                        required
                    />
                </FormControl> */}
            </div>
            <div className="modal-footer">
                <Button
                    className="modal-button-secondary"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    className="modal-button-primary"
                    disabled={!state.name || !state.country || !state.location}
                >
                    Submit
                </Button>
            </div>
        </Box>
    );
});

export default CreateCounterParty;
